module.exports = __webpack_public_path__ + "media/images/lb/679-0316086c85be7f23de1401dc5e2b38e5.svg";